// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/query-similar-patients.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New(
  $first_name: String!
  $last_name: String!
  $birth_date: date!
) {
  vaxiom_persons_aggregate(
    where: {
      first_name: { _eq: $first_name }
      last_name: { _eq: $last_name }
      birth_date: { _eq: $birth_date }
    }
  ) {
    aggregate {
      count
    }
  }
}

`